import { __decorate, __metadata } from "tslib";
import { lazyAppContextConsumer } from '@1inch-community/core/lazy';
import { subscribe } from '@1inch-community/core/lit-utils';
import { BigFloat } from '@1inch-community/core/math';
import '@1inch-community/ui-components/number-animation';
import { Task } from '@lit/task';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tap } from 'rxjs';
import { tooltip } from '../tooltip';
let FiatAmountViewElement = class FiatAmountViewElement extends LitElement {
    constructor() {
        super(...arguments);
        this.amount = BigFloat.zero();
        this.applicationContext = lazyAppContextConsumer(this);
        this.task = new Task(this, async ([tokenRecordId, amount]) => {
            if (!tokenRecordId)
                throw new Error('');
            const price = await this.applicationContext.value.tokenStorage.getTokenFiatPrice({
                tokenRecordId,
            });
            return price.mul(amount);
        }, () => [this.tokenId, this.amount]);
    }
    static { this.tagName = 'inch-fiat-amount-view'; }
    firstUpdated() {
        subscribe(this, [
            this.applicationContext.value.onChain.crossChainEmitter.pipe(tap(() => this.task.run([this.tokenId, this.amount]))),
        ], { requestUpdate: false });
    }
    render() {
        return this.task.render({
            complete: () => this.renderValue(),
            pending: () => this.renderValue(),
            error: () => this.renderValue(),
        });
    }
    renderValue() {
        const amount = this.task.value;
        if (!amount) {
            return html ``;
        }
        return html `
      <inch-number-animation
        ${tooltip(`$${amount.toFixedSmart(9)}`)}
        .value="${amount.toFixedSmart(2)}"
        prefixSymbol="$"
      ></inch-number-animation>
    `;
    }
};
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], FiatAmountViewElement.prototype, "tokenId", void 0);
__decorate([
    property({ type: Object, attribute: false }),
    __metadata("design:type", Object)
], FiatAmountViewElement.prototype, "amount", void 0);
FiatAmountViewElement = __decorate([
    customElement(FiatAmountViewElement.tagName)
], FiatAmountViewElement);
export { FiatAmountViewElement };
//# sourceMappingURL=fiat-amount-view.element.js.map